import { getLocale } from "../runtime";

const sv_minicarttitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Min varukorg`
};

const minicarttitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_minicarttitle(inputs)
	return "miniCartTitle";
};

export { minicarttitle as "miniCartTitle" };